import { Model as ORMModel, attr, many } from 'redux-orm'
import { Types } from '@fedsim/actions'
import { getId } from '@fedsim/helpers'
import { Wrestler as WrestlerSM } from 'stateMachines/wrestler'
import { SegmentsMetaCollection } from '@fedsim/constants'

export function getCostByPoints(points = 25) {
  return points < 50 ? 10000 : points < 60 ? 20000 : points < 70 ? 25000 : points < 80 ? 30000 : points < 90 ? 35000 : points < 95 ? 50000 : 60000

}
export default class Wrestler extends ORMModel {
  static get alignmentTypes() {
    return {
      DEFAULT: 'NEUTRAL',
      BAD: 'BAD',
      NEUTRAL: 'NEUTRAL',
      GOOD: 'GOOD'
    }
  }
  static get genderOptions() {
    return {
      DEFAULT: 'MALE',
      MALE: 'MALE',
      FEMALE: 'FEMALE'
    }
  }
  static get roleTypes() {
    return {
      DEFAULT: 'SPECIALIST',
      BRUISER: 'BRUISER',
      FIGHTER: 'FIGHTER',
      SPECIALIST: 'SPECIALIST',
      CRUISER: 'CRUISER',
      GIANT: 'GIANT'
    }
  }
  static get fields() {
    return {
      id: attr(),

      name: attr({ getDefault: () => '' }),
      nickname: attr({ getDefault: () => '' }),
      desc: attr({ getDefault: () => '' }),
      image: attr({ getDefault: () => '' }),
      entranceVideoUrl: attr({ getDefault: () => null }),

      brandIds: many({
        to: 'Brand',
        as: 'brands',
        relatedName: 'WrestlerBrands'
      }),

      goalIds: many({
        to: 'Wrestler',
        as: 'goals',
        relatedName: 'WrestlerGoals'
      }),

      region: attr({ getDefault: () => '' }),
      country: attr({ getDefault: () => '' }),
      dob: attr({ getDefault: () => null }),

      height: attr({ getDefault: () => 180 }),
      weight: attr({ getDefault: () => 100 }),

      alignment: attr({ getDefault: () => Wrestler.alignmentTypes.DEFAULT }),
      gender: attr({ getDefault: () => Wrestler.genderOptions.DEFAULT }),
      role: attr({ getDefault: () => Wrestler.roleTypes.DEFAULT }),
      tier: attr({ getDefault: () => 1 }),

      followers: attr({ getDefault: () => 0 }),
      // draws: attr({ getDefault: () => 0 }),
      losses: attr({ getDefault: () => 0 }),
      wins: attr({ getDefault: () => 0 }),
      streak: attr({ getDefault: () => 0 }),

      points: attr({ getDefault: () => 50 }),
      morale: attr({ getDefault: () => 100 }),

      stamina: attr({ getDefault: () => 75 }),
      popularity: attr({ getDefault: () => 70 }),
      charisma: attr({ getDefault: () => 70 }),

      damage: attr({ getDefault: () => 0 }),
      active: attr({ getDefault: () => true }),

      cost: attr({ getDefault: () => 25 })
    }
  }

  static reducer(action, Wrestler, session) {
    let item
    switch (action.type) {
      case Types.RESET:
      case Types.RESET_WRESTLERS:
        session.Wrestler.all()
          .toModelArray()
          .forEach(item => item.delete())
        break
      case Types.ADD_WRESTLER: {
        const cost = getCostByPoints(action?.payload?.points || 25);

        session.Wrestler.upsert({ id: getId(), cost, ...action.payload })
        break
      }
      case Types.GENERATE_WRESTLERS:
        action?.payload.forEach(item => {
          item.cost = getCostByPoints(item?.points)

          session.Wrestler.upsert(item)
        })
        break
      case Types.DELETE_BRAND:
        session.Wrestler.all()
          .toModelArray()
          .forEach(item => {
            item = session.Wrestler.withId(item.id)
            item.brandIds = [
              ...item.brandIds.filter(id => id === action.payload.id)
            ]

            item.update(action.payload)
          })

        break
      case Types.RESET_BRAND_ID_FOR_WRESTLERS:
        session?.Wrestler?.all()
          ?.toModelArray()
          ?.forEach(item => {
            item = Wrestler.withId(item.id)
            item.brandId = []

            item.update(action.payload)
          })
        break
      case Types.PRODUCTION_COMPLETE_WRESTLERS:
        const production = session?.Production?.withId(action.payload.id)
        const wrestlers = session?.Wrestler?.all()?.toRefArray()
        const segments = session?.Segment?.all()?.filter(item => production?.segmentIds?.includes(item.id))?.toRefArray()
        const segmentIds = segments?.filter(item => {
          const type = SegmentsMetaCollection.find(meta => meta.type === item.type)


          return type.category === 'Competition'
        }).map(item => item.id)
        const appearances = session?.Appearance?.all()
          ?.filter(item => segmentIds.includes(item.segmentId))
          ?.toRefArray()

        const winnerIds = appearances.filter(
          appearance =>
            segmentIds?.includes(appearance.segmentId) &&
            appearance.winner
        ).map(item => item.wrestlerId)
        const loserIds = appearances.filter(
          appearance =>
            segmentIds.includes(appearance.segmentId) &&
            !appearance.winner
        ).map(item => item.wrestlerId)

        const winners = wrestlers.filter(item => winnerIds.includes(item.id))
        const losers = wrestlers.filter(item => loserIds.includes(item.id))

        winners.forEach(item => {
          const foundItem = Wrestler.withId(item.id)
          if (foundItem) {
            const newModel = new WrestlerSM(foundItem._fields)
              .recordWin()
              .recordFuzz()
              .getState()

            foundItem.update(newModel)
          }
        })
        losers.forEach(item => {
          const foundItem = session.Wrestler.withId(item.id)
          if (foundItem) {
            const newModel = new WrestlerSM(foundItem._fields)
              .recordLoss()
              .recordFuzz()
              .getState()

            foundItem.update(newModel)
          }
        })
        break
      case Types.UPDATE_WRESTLER:
        item = session.Wrestler.withId(action.payload.id)

        if (item) {
          action.payload.cost = getCostByPoints(action?.payload?.points || item?.points || 25);

          item.update(action.payload);
        }
        break

      case Types.BOOST_WRESTLER:
        session.Wrestler.all()
          .toModelArray()
          .filter(item => item.id === action.payload.id)
          .forEach(item => {
            const morale = item.morale + 1
            const popularity = item.popularity + 1
            const damage = item.damage - 1
            const charisma = item.charisma + 1
            const stamina = item.stamina + 1
            const points = item.points + 1
            const newModel = Object.assign({}, { id: item.id, damage, morale, popularity, charisma, stamina, points })

            item.update(newModel)
          })
        break

      case Types.WEEK_PROCESS:
        session.Wrestler.all()
          .toModelArray()
          .forEach(item => {
            const damage = item.damage > 0 ? item.damage - .5 : item.damage
            const newModel = Object.assign({}, { id: item.id, damage })

            item.update(newModel)
          })
        break

      case Types.PENALTY_WRESTLER:
        session.Wrestler.all()
          .toModelArray()
          .filter(item => item.id === action.payload.id)
          .forEach(item => {
            // happy to be involved
            const morale = item.morale + .5
            // more screen time is always a plus
            const popularity = item.popularity + .5
            // more screen time is always a plus
            const damage = item.damage + .5
            // more experience is more experience
            const charisma = item.charisma + .5
            // more usage more stamina
            const stamina = item.stamina + .1
            // the only real loss, the penalty
            const points = item.points - .5

            const newModel = Object.assign({}, item, { morale, damage, popularity, charisma, stamina, points })

            item.update(newModel)
          })
        break

      case Types.DELETE_WRESTLER: {
        session.Wrestler.withId(action.payload.id).delete()
        break
      }
    }
  }
}
